import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { AppStorageService, StorageLocation } from '../app-store/app-storage.service';
import { environment } from '@config/environments/environment';
import { duongDanCongSvMoi } from '@core/guards/redirect-cong-sv-moi.guard';

@Injectable({
  providedIn: 'root',
})
export class AppRoutingService {
  constructor(
    private readonly router: Router,
    private readonly storage: AppStorageService
  ) { }

  /**
   * Chuyển hướng đến trang trước đó.
   * Nếu không tìm thấy URL trước đó, chuyển hướng đến trang chủ mặc định.
   */
  navigateToPreviousPage() {
    const previousUrl = this.storage.getItem<string>(
      this.storage.localStorageKeys.global.routing.previousUrl,
      { location: StorageLocation.LOCAL_STORAGE }
    );
    window.location.href = previousUrl ?? '';
  }

  /**
   * Chuyển hướng đến trang chủ.
   */
  navigateToHomePage(): void {
    this.router.navigate(['']);
  }

  /**
   * Chuyển hướng đến trang đăng nhập.
   */
  /**
   * ⚠ S03: đích là trang đăng nhập của **cổng sinh viên mới**.
   *
   * Trước đây dùng `environment.domain.urlWebLogIn` — SAI vai trò: khoá đó kiêm
   * `backlink` của SSO (`authen.config.ts` §sso), và ở prod nó trỏ về chính app
   * này (`sinhvien2`) chứ không phải một trang đăng nhập.
   *
   * Chưa khai `urlCongSvMoi` thì rơi về `/login` nội bộ — mà route đó cũng đã có
   * guard chuyển hướng, nên hai đường gặp nhau ở cùng một chỗ.
   */
  navigateToLoginPage(): void {
    const dich = duongDanCongSvMoi('/login');
    if (dich) {
      window.location.href = dich;
      return;
    }
    this.router.navigate(['login']);
  }

  navigateToLoginPageAsync() {
    const dich = duongDanCongSvMoi('/login');
    if (dich) {
      return (window.location.href = dich);
    }
    return this.router.navigate(['login']);
  }

  /**
   * Chuyển hướng đến trang lỗi truy cập không được phép (403).
   */
  navigateToUnauthorizedPage(): void {
    this.router.navigateByUrl('error?s=403');
  }

  /**
   * Chuyển hướng đến trang lỗi máy chủ nội bộ (500).
   */
  navigateToInternalServerErrorPage(): void {
    this.router.navigateByUrl('error?s=500');
  }

  /**
   * Chuyển hướng đến trang không tìm thấy (404).
   */
  navigateToNotFoundPage(): void {
    this.router.navigateByUrl('error?s=404');
  }
}
